import * as actions from "./rentRegistration.actions";
import * as api from "./rentRegistration.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./rentRegistration.constants";
import * as hooks from "./rentRegistration.hooks";
import * as promises from "./rentRegistration.promises";
import reducer from "./rentRegistration.reducer";
import { saga } from "./rentRegistration.saga";
import * as selectors from "./rentRegistration.selectors";
import * as utils from "./rentRegistration.utils";
export * from "./rentRegistration.types";
export var REDUCER_KEY_RENT_REGISTRATION = REDUCER_KEY;
export var rentRegistrationModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
